import { Image, RichText, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import { FieldEditFrame } from 'src/utils/customFieldEditFrame';
import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import { EditorHelp } from 'src/components/layout/_EditorHelp/_EditorHelp';

import ContentOverviewHeaderContainer from '../_contentOverviewHeaderContainer/ContentOverviewHeaderContainer';

import { ContentOverviewCallToActionProps } from './ContentOverviewCallToActionProps';

import styles from './ContentOverviewCallToAction.module.css';

export default function ContentOverviewCallToAction(props: ContentOverviewCallToActionProps): JSX.Element {
	const isEditing = IsSitecoreEditing();
	if (!isEditing && !props.fields) {
		return <></>;
	}

	const backgroundColour = props.fields?.BackgroundColour && styles[props.fields?.BackgroundColour?.value.toLowerCase()];

	const border = props.fields?.Border?.value && styles.border;

	const boxShadow = props.fields?.BoxShadow?.value && styles.boxShadow;

	return (
		<div className={`${styles.contentOverviewCallToActionContainer} maxWidth pad`} data-display-pdf-download>
			{props.fields?.HideTitleSubtitle !== true && (
				<ContentOverviewHeaderContainer
					header={props.fields?.Title?.value ? props.fields.Title.value : ''}
					subHeader={props.fields?.Subtitle?.value}
				/>
			)}
			<FieldEditFrame
				itemId={props.rendering?.dataSource ?? undefined}
				fields={['BackgroundColour', 'Border', 'BoxShadow']}
				header="Edit Call To Action"
			>
				<EditorHelp text={'Click here to change the appearance of the Call To Action'} />
				<div className={`${styles.ctaContainer} ${backgroundColour} ${border} ${boxShadow}`}>
					<div className={styles.contentContainer}>
						<Text tag="h1" field={props.fields?.Heading} className={styles.contentHeader} />

						<RichText tag="div" field={props.fields?.Content} />
					</div>

					<div className={styles.ctaImageContainer}>
						<Image field={props.fields?.Image} className={`${styles.ctaImage}`} />
					</div>
				</div>
			</FieldEditFrame>
		</div>
	);
}
